import ayalconfig from "../ayalconfig";
import router from "../router";
import Logger from "./logger";

const logger = new Logger();
export default class Service {

    redirectToHomePage(){
        logger.debug("Redirecting to home screeb");
        this.navigateTo('Login');
    }

    getBaseUrl(){
        const baseUrl = ayalconfig.baseUrl();
        return baseUrl;
    }

    isConnectionAvailable(url){
        return fetch(url, { method: 'HEAD', mode: 'no-cors' })
            .then(function(resp) {
                return resp && (resp.ok || resp.type === 'opaque');
            })
            .catch(function(err) {
                console.warn('[conn test failure]:', err);
            });
    }

    navigateTo(name, params){
        router.push({name:name, params: params})
    }

    formatData(param, allQuestionsList){
        var allParams = [];

        var survey = param;
        if(!survey){
            return
        }
        var questionCHoicesPair = this.constructCHoices(survey);
        let choiceMap = questionCHoicesPair.choiceMap;
        let _allQuestionsList = allQuestionsList;
        for(var data of questionCHoicesPair.keyset){
            var splits = data.split("_");
            var answerType = splits[1];
            var questionId = splits[2];
            var response = survey[data];
            if("MultipleChoice" === answerType || "RadioList" === answerType || "YesNoType" === answerType || "NoYesType" === answerType || "DropdownCustom" === answerType || "SingleChoice" === answerType || "CityStreet" === answerType || "City" === answerType){
                response = choiceMap[questionId];
            } else if("ListInput" === answerType){
                response = this.createResponseFromList(response);
            }
            let question ="";
            allParams.push(this.addToResponse(questionId, question, answerType, response));
            _allQuestionsList = this.removeFromArray(_allQuestionsList,questionId);
        }
        for(let _a of _allQuestionsList){
            allParams.push(this.addToResponse(_a, '', '', ''));
        }

        return allParams;
    }

    addToResponse(questionId, question, answerType, response) {
        var allParams = {};
        allParams.questionId = questionId;
        allParams.question = question;
        allParams.answerType = answerType;
        allParams.response = response;
        return allParams;
    }

    createResponseFromList(response) {
        var re = [];
        var res = response.split(",");
        for(var ix of res){
            if(ix){
                re.push(ix);
            }
        }
        return re;
    }

    constructCHoices(survey){

        var _map = {choiceMap:'', keyset:''};
        let _set = new Set();
        var choiceMap = new Object();
        for(var data in survey) {

            var splits = data.split("_");
            var answerType = splits[1];
            var questionId = splits[2];
            if("MultipleChoice" === answerType || "RadioList" === answerType || "YesNoType" === answerType || "NoYesType" === answerType || "DropdownCustom" === answerType || "SingleChoice" === answerType){

                var response = survey[data];
                if(!response){
                    continue;
                }
                if(!response.choice){
                    continue;
                }
                if(answerType === "MultipleChoice"){
                    let e = "question_"+answerType +"_"+questionId;
                    _set.add(e);
                }else {
                    _set.add(data);
                }
                if(answerType === "DropdownCustom"){
                    // let choiceList = [];
                    // for(let resp of response){
                    //     choiceList.push(resp.choice);
                    // }
                    choiceMap[questionId] = {choiceId:response.choiceId, choiceNumber:response.choiceNumber, choice: response.choice}
                } else if(answerType === "MultipleChoice"){

                    if(!choiceMap.hasOwnProperty(questionId)){
                        choiceMap[questionId] = [];
                    }
                    let input = '';
                    if(response.hasTextField){
                        let formatedInputVar = 'question_' + answerType + "_"+questionId+"_"+response.choiceId+"_input";
                        input = survey[formatedInputVar]?survey[formatedInputVar]:'';
                    }
                    choiceMap[questionId].push({choiceId:response.choiceId, choice:response.choice,choiceNumber:response.choiceNumber, input: input});
                } else if(answerType === "RadioList" || answerType === "YesNoType" || answerType === "NoYesType"){
                    let input = '';
                    if(response.hasTextField){
                        let formatedInputVar = 'question_' + answerType + "_"+questionId+"_"+response.choiceId+"_input";
                        input = survey[formatedInputVar]?survey[formatedInputVar]:'';
                    }
                    choiceMap[questionId] = {choiceId:response.choiceId, choice: response.choice, choiceNumber:response.choiceNumber, input: input}
                } else {

                    choiceMap[questionId] = response.choice;
                }

            }else if("City" === answerType){
                let cityString = 'question_'+answerType+'_'+questionId;
                const cityResponses = survey[cityString];
                if(cityResponses){
                    const displayCityAndStreetCodeOnly = ayalconfig.displayCityAndStreetCodeOnly;
                    if(!choiceMap.hasOwnProperty(questionId)){
                        _set.add(cityString);
                        choiceMap[questionId] = cityResponses.code?cityResponses.code:'' + '' + (displayCityAndStreetCodeOnly?'':' | '+ cityResponses.choice);
                    }
                }
            }else if("CityStreet" === answerType){

                let streetString ='question_' + answerType + "_"+questionId+"_street";
                let neighourString ='question_' + answerType + "_"+questionId+"_neighbourhood";
                let houseString ='question_' + answerType + "_"+questionId+"_houseNumber";
                let cityString = 'question_'+answerType+'_'+questionId;
                const cityResponses = survey[cityString];
                if(cityResponses){

                    const displayCityAndStreetCodeOnly = ayalconfig.displayCityAndStreetCodeOnly;
                    if(!choiceMap.hasOwnProperty(questionId)){

                        const cityResponses = survey[cityString];
                        _set.add(cityString);
                        // choiceMap[questionId] = {};
                        choiceMap[questionId] = {"choice":{"city":'', "street":'', "neighbourhood":'', "houseNumber":''}};
                        let cityNameString = cityResponses.code?cityResponses.code:'' + '' + (displayCityAndStreetCodeOnly?'':' | '+ cityResponses.choice);
                        choiceMap[questionId]['choice']['city'] = cityNameString
                        // let prevString = choiceMap[questionId]['choice'];
                        // choiceMap[questionId]['choice']= cityNameString +( prevString? ',' + prevString:'')

                    }
                    if(streetString === data) {
                        const streetResponses = survey[streetString];
                        // let prevString = choiceMap[questionId]['choice'];
                        // choiceMap[questionId]['choice']=  prevString + ',' + streetResponses.code + '' + (displayCityAndStreetCodeOnly ? '' : ' | ' + streetResponses.choice);
                        choiceMap[questionId]['choice']['street'] = (streetResponses?streetResponses.code:'') + '' + (displayCityAndStreetCodeOnly ? '' : ' | ' + streetResponses.choice);
                    }
                    if(neighourString === data){
                        // let prevString = choiceMap[questionId]['choice'];
                        // choiceMap[questionId]['choice']= prevString + (survey[neighourString]?',' + survey[neighourString]:'');
                        choiceMap[questionId]['choice']['neighbourhood'] = survey[neighourString]
                    }
                    if(houseString === data){
                        // let prevString = choiceMap[questionId]['choice'];
                        // choiceMap[questionId]['choice']= prevString +(survey[houseString]? ',' + survey[houseString]:'');
                        choiceMap[questionId]['choice']['houseNumber'] = survey[houseString];
                    }
                }
            }else {
                _set.add(data);
            }
        }
        _map.keyset = _set;
        _map.choiceMap = choiceMap;
        return _map;
    }

    removeFromArray(allQuestionsList,questionId){
        return allQuestionsList.filter(key => {
            return key !== questionId;
        });

    }
    showPosition(position, doAfterSuccess) {
        var location = {
            longitude: position.coords.longitude,
            latitude: position.coords.latitude
        }
        logger.debug("Getting Location: "+JSON.stringify(location));
        doAfterSuccess(location);
        // this.userInfo.location = location;
    }
    getLocation(doAfterSuccess) {
        var options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
        };
        // Accept optional error callback as second argument
        var errorCallback = arguments[1] || function(e){ logger.debug("Error finding location ", e); };
        if(navigator.geolocation) {
            return navigator.geolocation.getCurrentPosition(
                (v) => this.showPosition(v, doAfterSuccess),
                errorCallback,
                options
            );
        } else {
            logger.debug("Geo Location not supported by browser");
            if(typeof errorCallback === 'function') errorCallback({ message: 'Geo Location not supported by browser' });
        }
    }
}
export function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}